if (typeof window.dogBreedSelectorInitialized === 'undefined') {
  window.dogBreedSelectorInitialized = true;

  function searchresultbreed(input) {
    let get_value = input.value.toLowerCase();
    let dropdown = input.closest(".suggestion-container").querySelector(".dropdown-content");
    let breedLinks = dropdown.querySelectorAll(".option-list");

    breedLinks.forEach(function (breed) {
      let breed_html = breed.innerHTML.toLowerCase();
      breed.style.display = breed_html.includes(get_value) ? "block" : "none";
    });
  }

  let toggleDropdownBtn = document.querySelectorAll(".suggestion-container .toggle-dropdown-btn");
  let dropdownContent = document.querySelectorAll(".suggestion-container .dropdown-content .option-list");

  if(toggleDropdownBtn){
    toggleDropdownBtn.forEach(function (btn) {
      btn.addEventListener("click", function () {
        let container = this.closest(".suggestion-container");
        let content_element = container.querySelector(".dropdown-content");
        content_element.classList.toggle("hide");
        if (!content_element.classList.contains("hide")) {
          let input = container.querySelector(".search-results-input");
          if (input) {
            input.focus();
          }
        }
      });
    });
  }

  if(dropdownContent){
    dropdownContent.forEach(function (breed) {
      breed.addEventListener("click", function () {
        let container = this.closest(".suggestion-container");
        let selected_breed = this.innerHTML;
        let selected_size = this.getAttribute("data-value");
        let content_element = container.querySelector(".dropdown-content");
        content_element.classList.add("hide");
        
        container.querySelector(".btn-changeable-text").innerHTML = selected_breed;
        
        let recommendationSection = container.querySelector(".recommendation-section");

        if (recommendationSection) {
          recommendationSection.classList.remove("hide");
          recommendationSection.querySelector(".selected-value-title-phrase").innerHTML = "För din " + selected_breed + ", Vi rekommenderar:";
          recommendationSection.querySelector(".selected-value").innerHTML = selected_size;
        }
              
          let variantsSelector = null;
          const sizeGuidePopup = container.closest('.size-guide-popup');

          if (sizeGuidePopup) {
            const sectionId = sizeGuidePopup.id.replace('sizeGuidePopup-', '');
            variantsSelector =
              document.getElementById(`variant-selects-${sectionId}`) ||
              document.querySelector(`variant-selects[data-section="${sectionId}"]`);
          }

          if (!variantsSelector) {
            variantsSelector =
              container.closest('section, .product, .product__info, .product-form')
                ?.querySelector('.mff_variant-selects') ||
              container.parentElement.querySelector('.mff_variant-selects');
          }

          if (variantsSelector) {
            let selectElement = variantsSelector.querySelector('select.mff_select__select[data-id^="Storlek"]');

            if (selectElement) {
              let matchingOption = Array.from(selectElement.options || []).find(option => {
                let optionSize = option?.value?.split(/-|–|_/)[0]?.trim();
                return optionSize?.toLowerCase() === selected_size.toLowerCase();
              });


              if (matchingOption) {
                selectElement.value = matchingOption.value;
                const changeEvent = new Event("change", { bubbles: true, cancelable: true });
                selectElement.dispatchEvent(changeEvent);
              } else {
                if (recommendationSection) {
                  recommendationSection.classList.remove("hide");
                  recommendationSection.querySelector(".selected-value-title-phrase").innerHTML = `För din ${selected_breed}, inget matchande resultat hittades!`;
                  recommendationSection.querySelector(".selected-value").innerHTML = "";
                }
              }

            } else {
              let radioInputs = variantsSelector.querySelectorAll('input[type="radio"][data-id^="Storlek"]');
              
              if (radioInputs.length > 0) {
                let matchingRadio = Array.from(radioInputs).find(radio => {
                  let optionSize = radio.value?.split(/-|–|_/)[0]?.trim();
                  return optionSize?.toLowerCase() === selected_size.toLowerCase();
                });

                if (matchingRadio) {
                  matchingRadio.checked = true;
                  const changeEvent = new Event("change", { bubbles: true, cancelable: true });
                  matchingRadio.dispatchEvent(changeEvent);
                  matchingRadio.dispatchEvent(new Event("input", { bubbles: true }));
                } else {
                  if (recommendationSection) {
                    recommendationSection.classList.remove("hide");
                    recommendationSection.querySelector(".selected-value-title-phrase").innerHTML = `För din ${selected_breed}, inget matchande resultat hittades!`;
                    recommendationSection.querySelector(".selected-value").innerHTML = "";
                  }
                }
              } else {
                console.log("No matching form element found for the selected breed");
              }
            }
          }
      });
    });
  }

  document.addEventListener("click", function (event) {
    document
      .querySelectorAll(".suggestion-container .dropdown-content")
      .forEach(function (dropdown) {
        if (!dropdown.closest(".suggestion-container").contains(event.target)) {
          dropdown.classList.add("hide");
        }
      });
  });
}